import React from "react";
import i18n from "src/locales";

import scale from "./images/scale.svg";
import calories from "./images/calories.svg";
import styled from "@emotion/styled";
import { breakpointMobileExtended } from "src/design-system/styles/breakpoints";
import { List } from "src/design-system/layouts/List/List";
import Button from "src/design-system/components/Button/Button";

const Container = styled.div`
  align-items: inherit;
  justify-content: left;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;

  width: 70%;

  @media ${breakpointMobileExtended} {
    align-self: inherit;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    margin-top: calc(1em + 10px);
    margin-bottom: 40px;
  }
`;

const Icon = styled.img`
  margin-right: 1em;
  margin-left: calc(1em - 16px);
`;

function CTAButton<T>({
  goal,
  onClick,
  leftAlign,
  children,
}: {
  goal?: T;
  onClick: (goal: T) => void;
  leftAlign?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Button
      onClick={() => onClick(goal)}
      data-cy={`landing-cta${goal ? `-${goal}` : ""}`}
      css={
        leftAlign && {
          fontSize: 20,
          fontWeight: "normal",
          letterSpacing: 1,
          justifyContent: "left",
        }
      }
    >
      {children}
    </Button>
  );
}

export function IntroCTA({
  shouldUseDualLogoCTA,
  onStartSurvey,
  onAddHealthGoal,
}: {
  shouldUseDualLogoCTA: boolean;
  onStartSurvey: () => void;
  onAddHealthGoal: (string) => void;
}) {
  let buttons;
  if (!shouldUseDualLogoCTA) {
    buttons = (
      <CTAButton onClick={onStartSurvey}>
        {i18n.t("introv3:continue")}
      </CTAButton>
    );
  } else {
    buttons = (
      <List>
        <CTAButton goal="lose" onClick={onAddHealthGoal} leftAlign>
          <Icon src={scale} alt="" />
          {i18n.t("introv3:loseWeight")}
        </CTAButton>
        <CTAButton goal="fit" onClick={onAddHealthGoal} leftAlign>
          <Icon src={calories} alt="" />
          {i18n.t("introv3:getFit")}
        </CTAButton>
      </List>
    );
  }

  return <Container>{buttons}</Container>;
}
